import * as actions from "./actions";

let initialState = {
  balances: {
    error: null,
    sending: false,
    sent: false,
    data: [],
  },
  transactionOrders: {
    error: null,
    sending: false,
    sent: false,
    data: [],
  },
  depositToCash: {
    error: null,
    sending: false,
    sent: false,
  },
  withdrawFromCash: {
    error: null,
    sending: false,
    sent: false,
  },
  withdrawFromFee: {
    error: null,
    sending: false,
    sent: false,
  },
};

const settings = (state = initialState, action) => {
  switch (action.type) {
    case actions.LOANSTEP_BALANCES_REQUEST:
      return Object.assign({}, state, {
        balances: Object.assign({}, state.balances, {
          sending: true,
        }),
      });
    case actions.LOANSTEP_BALANCES_SUCCESS:
      return Object.assign({}, state, {
        balances: Object.assign({}, state.balances, {
          sending: false,
          sent: true,
          error: null,
          data: action.response,
        }),
      });
    case actions.LOANSTEP_BALANCES_ERROR:
      return Object.assign({}, state, {
        balances: Object.assign({}, state.balances, {
          sending: false,
          sent: true,
          error: action.error,
        }),
      });
    case actions.LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_ORDERS_REQUEST:
      return Object.assign({}, state, {
        transactionOrders: Object.assign({}, state.transactionOrders, {
          sending: true,
        }),
      });
    case actions.LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_ORDERS_SUCCESS:
      return Object.assign({}, state, {
        transactionOrders: Object.assign({}, state.transactionOrders, {
          sending: false,
          sent: true,
          error: null,
          data: action.response,
        }),
      });
    case actions.LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_ORDERS_ERROR:
      return Object.assign({}, state, {
        transactionOrders: Object.assign({}, state.transactionOrders, {
          sending: false,
          sent: true,
          error: action.error,
        }),
      });
    case actions.LOANSTEP_SPECIAL_ACCOUNT_DEPOSIT_REQUEST:
      return Object.assign({}, state, {
        depositSpecialAccount: Object.assign({}, state.depositSpecialAccount, {
          sending: true,
        }),
      });
    case actions.LOANSTEP_SPECIAL_ACCOUNT_DEPOSIT_SUCCESS:
      return Object.assign({}, state, {
        depositSpecialAccount: Object.assign({}, state.depositSpecialAccount, {
          sending: false,
          sent: true,
          error: null,
        }),
      });
    case actions.LOANSTEP_SPECIAL_ACCOUNT_DEPOSIT_ERROR:
      return Object.assign({}, state, {
        depositSpecialAccount: Object.assign({}, state.depositSpecialAccount, {
          sending: false,
          sent: true,
          error: action.error,
        }),
      });
    case actions.LOANSTEP_SPECIAL_ACCOUNT_WITHDRAW_REQUEST:
      return Object.assign({}, state, {
        withdrawSpecialAccount: Object.assign(
          {},
          state.withdrawSpecialAccount,
          {
            sending: true,
          },
        ),
      });
    case actions.LOANSTEP_SPECIAL_ACCOUNT_WITHDRAW_SUCCESS:
      return Object.assign({}, state, {
        withdrawSpecialAccount: Object.assign(
          {},
          state.withdrawSpecialAccount,
          {
            sending: false,
            sent: true,
            error: null,
          },
        ),
      });
    case actions.LOANSTEP_SPECIAL_ACCOUNT_WITHDRAW_ERROR:
      return Object.assign({}, state, {
        withdrawSpecialAccount: Object.assign(
          {},
          state.withdrawSpecialAccount,
          {
            sending: false,
            sent: true,
            error: action.error,
          },
        ),
      });
    case actions.LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CONFIRM_REQUEST:
      return Object.assign({}, state, {
        confirmSpecialAccountTransaction: Object.assign(
          {},
          state.confirmSpecialAccountTransaction,
          {
            sending: true,
          },
        ),
      });
    case actions.LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CONFIRM_SUCCESS:
      return Object.assign({}, state, {
        confirmSpecialAccountTransaction: Object.assign(
          {},
          state.confirmSpecialAccountTransaction,
          {
            sending: false,
            sent: true,
            error: null,
          },
        ),
      });
    case actions.LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CONFIRM_ERROR:
      return Object.assign({}, state, {
        confirmSpecialAccountTransaction: Object.assign(
          {},
          state.confirmSpecialAccountTransaction,
          {
            sending: false,
            sent: true,
            error: action.error,
          },
        ),
      });
    case actions.LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CANCEL_REQUEST:
      return Object.assign({}, state, {
        cancelSpecialAccountTransaction: Object.assign(
          {},
          state.confirmSpecialAccountTransaction,
          {
            sending: true,
          },
        ),
      });
    case actions.LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CANCEL_SUCCESS:
      return Object.assign({}, state, {
        cancelSpecialAccountTransaction: Object.assign(
          {},
          state.confirmSpecialAccountTransaction,
          {
            sending: false,
            sent: true,
            error: null,
          },
        ),
      });
    case actions.LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CANCEL_ERROR:
      return Object.assign({}, state, {
        cancelSpecialAccountTransaction: Object.assign(
          {},
          state.confirmSpecialAccountTransaction,
          {
            sending: false,
            sent: true,
            error: action.error,
          },
        ),
      });
    default:
      return state;
  }
};

export default settings;
